import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { MedicalInsurance } from '../../../models/Entities/MedicalInsurances/MedicalInsurance';
import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { Label, MessageBarBody, Spinner, Switch, Text } from '@fluentui/react-components';
import { GuideDrawer } from '../../../theme/components/GuideDrawer';
import { GuideMessageBar } from '../../../theme/components/GuideMessageBar';

////i18Next
import { useTranslation } from 'react-i18next';

// Store
import * as MedicalInsuranceStore from '../../../redux/middleware/MedicalInsuranceMiddleware';

//styles
import './MedicalInsuranceMultiSelectorComponent.css';

export type SelectedMedicalInsuranceType = {
  medicalInsuranceId: number;
  ReferenceId: number;
};

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  SelectedMedicalInsurance: SelectedMedicalInsuranceType[];
  onSelect?: (medicalInsurance: MedicalInsurance) => void;
  onUnselect?: (medicalInsurance: SelectedMedicalInsuranceType) => void;
}

interface ConnectedProps {
  isLoading: boolean;
  loadingSuccess: boolean;
  failOnLoading: boolean;
  error: ErrorType;
  MedicalInsurances: MedicalInsurance[];
}

interface DispatchProps {
  GetAllMedicalInsurances: typeof MedicalInsuranceStore.actionCreators.GetAllMedicalInsurances;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const MedicalInsuranceMultiSelectorComponent = ({
  MedicalInsurances,
  isLoading,
  loadingSuccess,
  failOnLoading,
  error,
  SelectedMedicalInsurance,
  isOpen,
  openPanel: _openPanel,
  dismissPanel,
  onSelect,
  onUnselect,
  GetAllMedicalInsurances
}: Props) => {
  useEffect(() => {
    if (GetAllMedicalInsurances) GetAllMedicalInsurances(1, 200);
  }, [GetAllMedicalInsurances]);

  const HandleCancelForm = () => {
    dismissPanel();
  };

  const OnSelectMedicalInsurance = (medicalInsurance: MedicalInsurance) => {
    if (onSelect) onSelect(medicalInsurance);
  };

  //useTranslation()
  const [t] = useTranslation(); 
  const OnUnselectMedicalInsurance = (
    service: SelectedMedicalInsuranceType | undefined
  ) => {
    if (onUnselect && service) onUnselect(service);
  };

  const optionList = (
    <div className="MedicalInsuranceMultiSelectorContent">
      <GuideMessageBar intent="warning">
        <MessageBarBody>
          {t('medicalInsuranceMultiSelector.message.medicalInsurance')}
          &nbsp;{SelectedMedicalInsurance.length}&nbsp;
          {t('medicalInsuranceMultiSelector.message.medicalInsuranceSelected')}
        </MessageBarBody>
      </GuideMessageBar>

      <div className="SelectionMIListContainer">
        <div className="SelectionListRows">
          {MedicalInsurances &&
            MedicalInsurances.map((medicalInsurance: MedicalInsurance) => (
              <div key={medicalInsurance.id} className="SelectionListRow">
                <div className="SelectionList">
                  <Switch
                    checked={
                      SelectedMedicalInsurance.find(
                        (service: SelectedMedicalInsuranceType) =>
                          service.medicalInsuranceId === medicalInsurance.id
                      )
                        ? true
                        : false
                    }
                    onChange={(_, data) =>
                      data.checked
                        ? OnSelectMedicalInsurance(medicalInsurance)
                        : OnUnselectMedicalInsurance(
                            SelectedMedicalInsurance.find(
                              (service: SelectedMedicalInsuranceType) =>
                                service.medicalInsuranceId ===
                                medicalInsurance.id
                            )
                          )
                    }
                  />
                  <div className="SelectionList-item">
                    <Label weight="semibold">
                      {medicalInsurance.businessName}
                    </Label>
                    <Text>{medicalInsurance.title}</Text>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  return (
    <GuideDrawer
      open={isOpen}
      size="large"
      title={t('medicalInsuranceMultiSelector.modal.medicalProviders')}
      onDismiss={HandleCancelForm}
      testId="medical-insurance-multi-selector-drawer"
      secondaryAction={{ label: t('medicalInsuranceMultiSelector.footer.closeButton'), testId: 'medical-insurance-multi-selector-drawer-close' }}
    >
      {failOnLoading && (
        <GuideMessageBar intent="error">
          <MessageBarBody>{error?.ErrorMessage}</MessageBarBody>
        </GuideMessageBar>
      )}

      {isLoading ? (
        <Spinner label={t('medicalInsuranceMultiSelector.modal.loadingMedicalCoverage')} />
      ) : (
        optionList
      )}
    </GuideDrawer>
  );
};

const mapStateToProps = (state: AppState, ownprops: IProps) => ({
  isLoading: state.MedicalServices?.isLoadingAll,
  loadingSuccess: state.MedicalServices?.successLoadingAll,
  failOnLoading: state.MedicalServices?.failOnLoadingAll,
  error: state.MedicalServices?.error,
  MedicalInsurances: state.MedicalInsurances?.list
});

const mapDispatchToProps = {
  ...MedicalInsuranceStore.actionCreators
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MedicalInsuranceMultiSelectorComponent as any);
